// extracted by mini-css-extract-plugin
export var caption = "caption_image-module--caption--26LYR";
export var captionImage = "caption_image-module--captionImage--1NVOL";